export var FALLBACK_HANDLER_ID="@dicetechnology/doris-handler-fallback";